import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'Provinsi'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const provinsiCreate = 'master/Provinsi/create/'
export const provinsiList = 'master/Provinsi/list/'
export const provinsiDetail = 'master/Provinsi/detail/'
export const provinsiUpdate = 'master/Provinsi/update/'
export const provinsiInactive = 'master/Provinsi/inactive/'
export const provinsiActive = 'master/Provinsi/active/'
export const provinsiAll = 'master/Provinsi/get_province/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}